import Task from "../../../../core/model2/task/task"
import {Feature} from "../../../../core/gd/access-control/feature-access/const"
import taskView_addTimeReport from "../../actions/add-time-report"

const debug = false
// const debug = "taskView_getTimerOptions"

export default function taskView_getTimerOptions(task: Task, hidePopover: func) {
    const onStartTimer = () => {
        hidePopover()
        const isPro = gd.company.license.isPro

        debug && console.log(debug, 'onStartTimer', isPro)

        if (!isPro) {
            gd.modals.other.upgrade(Feature.TIME_TRACKING)
        } else {
            if (gd.taskTimers.isTimerActive(task.id)) gd.taskTimers.pauseTimer(task.id)
            else gd.taskTimers.startTimer(task)
            gd.bus.triggerEvent('task-view:time-tracking')
        }
    }

    const onStopTimer = () => {
        debug && console.log(debug, 'onStopTimer')
        hidePopover()
        gd.taskTimers.stopTimer(task.id, moment(task.momentCreated))
    }

    const onResumeTimer = () => {
        debug && console.log(debug, 'onResumeTimer')
        hidePopover()
        gd.taskTimers.toggleTimer(task)
    }

    const onReportTime = () => {
        debug && console.log(debug, 'onReportTime')
        hidePopover()
        taskView_addTimeReport(task)
    }

    const timer = gd.taskTimers.getTimer(task.id);
    const timerActive = timer ? timer.isActive() : false;

    const options = []
    if (!timer) {
        options.push({
            icon    : 'i5-play-solid',
            label   : 'Start timer',
            onClick : onStartTimer
        })
    }

    if (timer && timerActive) {
        options.push({
            icon    : 'i5-stop-solid',
            label   : 'Stop timer',
            onClick : onStopTimer
        })
    }

    if (timer && !timerActive) {
        options.push({
            icon    : 'i5-play-solid',
            label   : 'Resume timer',
            onClick : onResumeTimer
        })
    }

    options.push({
        icon    : 'i5-time-reported',
        label   : 'Report time',
        onClick : onReportTime
    })

    return options
}